import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "aero:inline-flex aero:items-center aero:justify-center aero:!rounded-md aero:border aero:px-2 aero:py-0.5 aero:text-xs aero:font-medium aero:w-fit aero:whitespace-nowrap aero:shrink-0 aero:[&>svg]:size-3 aero:gap-1 aero:[&>svg]:pointer-events-none aero:focus-visible:border-ring aero:focus-visible:ring-ring/50 aero:focus-visible:ring-[3px] aero:aria-invalid:ring-destructive/20 aero:dark:aria-invalid:ring-destructive/40 aero:aria-invalid:border-destructive aero:transition-[color,box-shadow] aero:overflow-hidden",
  {
    variants: {
      variant: {
        default:
          "aero:border-transparent aero:bg-brand-primary aero:text-brand-primary-foreground aero:shadow",
        secondary:
          "aero:border-transparent aero:bg-secondary aero:text-secondary-foreground aero:hover:bg-secondary/80",
        destructive:
          "aero:border-transparent aero:bg-destructive aero:text-destructive-foreground aero:shadow aero:hover:bg-destructive/80",
        outline: "aero:text-foreground",
        desctructive_outline:
          "aero:text-foreground aero:border-destructive aero:text-destructive aero:shadow aero:hover:bg-destructive/20",
        success:
          "aero:border-transparent aero:bg-green-100 aero:text-green-800 aero:border-green-300 aero:shadow aero:hover:bg-yellow/80",
        warning:
          "aero:border-transparent aero:bg-yellow-100 aero:text-yellow-800 aero:border-yellow-300 aero:shadow aero:hover:bg-yellow/80",
        // Multi-select chip variants from Figma
        editable:
          "aero:bg-brand-primary-50 aero:border-brand-primary-600 aero:text-brand-primary-600 aero:rounded-full aero:h-6 aero:px-2 aero:py-1 aero:gap-2 aero:text-xs aero:font-normal aero:leading-4",
        readonly:
          "aero:bg-neutral-50 aero:border-neutral-900 aero:text-foreground aero:rounded-full aero:h-6 aero:px-2 aero:py-1 aero:text-xs aero:font-normal aero:leading-4",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

function Badge({
  className,
  variant,
  asChild = false,
  ...props
}: React.ComponentProps<"span"> &
  VariantProps<typeof badgeVariants> & { asChild?: boolean }) {
  const Comp = asChild ? Slot : "span";

  return (
    <Comp
      data-slot="badge"
      className={cn(badgeVariants({ variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
